


































































































































































































import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import PartnerUsersFilter from "@/components/UserManagement/PartnerUsers/PartnerUsersFilter.vue";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { PartnerUserItem } from "@/store/user_management/partner_users/types";

@Component({ components: {PartnerUsersFilter, ScrollButton} })
export default class PartnerUsers extends BaseItemsPage<PartnerUserItem> {
  @Getter("partnerUsers") partnerUsersResponse: any;
  @Getter("partnerUserRoles") partnerUserRolesList: any;

  private is_show_filter = false;

  currentSort = "name";
  currentSortOrder = "desc";
  tableFields = ["name", "email", "partner", "status", "role"];

  getData(): any {
    return this.partnerUsersResponse;
  }

  getPartnerRolesNameById(id: number): string | undefined {
    let item = this.partnerUserRolesList.find((e: any) => e.id === id);
    return item ? item?.name
      : this.$i18n.tc("without_role");
  }
}
